import { PureComponent } from 'react';

import FormErrorMessage from 'components/FormErrorMessage';
import { Map as ImmutableMap } from 'immutable';
import get from 'lodash/get';

export default class TextRowField extends PureComponent {
  constructor(props) {
    super(props);

    const selected = props.input.value.split(',');
    this.state = {
      checks: Object.keys(props.options).reduce(
        (acc, key) => acc.set(key, selected.indexOf(key) > -1),
        new ImmutableMap(),
      ),
      filter: '',
    };
  }

  getRowValue = (key) => {
    const { textRow } = this.props;
    switch (key) {
      case 'networkDevicesDiscovered':
        return textRow.deviceCount;
      case 'networkInterfacesActivetotal':
        return `${textRow.interfaceActiveCount}/${textRow.interfaceCount}`;
      case 'interfaceEdgeCount':
        return textRow.interfaceEdgeCount;
      case 'numberOfHost':
        return textRow.userCount;
      default:
        return '';
    }
  };

  getTableRows = (filteredItems) => {
    const { options, input } = this.props;
    const selected = input.value.split(',');

    return filteredItems.map((key) => (
      <tr key={key}>
        <td className='dashboard-text-row-form-first__td'>
          <input
            type='checkbox'
            name={key}
            checked={selected.indexOf(key) > -1}
            onChange={this.handleChange}
          />
        </td>
        <td>
          {options[key]}
          <span className='float-right'>{this.getRowValue(key)}</span>
        </td>
      </tr>
    ));
  };

  getAllValue = (filteredItems) => {
    const { checks } = this.state;
    const checkedValues = filteredItems.filter((item) => checks.get(item));
    return checkedValues.length === filteredItems.length;
  };

  getFilteredItems = () => {
    const { options } = this.props;
    const { filter } = this.state;
    const items = Object.keys(options);
    const re = new RegExp(filter, 'i');
    const filteredItems =
      filter === '' ? items : items.filter((key) => re.test(options[key]));
    return filteredItems;
  };

  handleChange = ({ target: { checked, name } }) => {
    this.setState({ checks: this.state.checks.set(name, checked) }, () =>
      this.updateForm(),
    );
  };

  handleChangeAll = ({ target: { checked } }) => {
    const filteredItems = this.getFilteredItems();
    this.setState(
      {
        checks: this.state.checks.map((_v, k) => {
          if (filteredItems.indexOf(k) > -1) {
            return checked;
          }
          return !checked;
        }),
      },
      () => this.updateForm(),
    );
  };

  handleFilterChange = ({ target: { value } }) => {
    this.setState({ filter: value });
  };

  updateForm = () => {
    const { input } = this.props;
    input.onChange(
      this.state.checks
        .reduce((acc, val, key) => {
          if (!val) {
            return acc;
          }
          return acc.concat(key);
        }, [])
        .join(','),
    );
  };

  render() {
    const {
      meta: { touched, error },
      msg,
    } = this.props;
    const { filter } = this.state;
    const filteredItems = this.getFilteredItems();
    return (
      <div>
        <table className='table-bordered dashboard-text-row-form__table table'>
          <thead>
            <tr>
              <th />
              <th>{get(msg, ['dialog', 'textRow', 'name'])}</th>
            </tr>
            <tr>
              <td className='dashboard-text-row-form-first__td'>
                <input
                  type='checkbox'
                  checked={this.getAllValue(filteredItems)}
                  onChange={this.handleChangeAll}
                />
              </td>
              <td>
                <input
                  type='text'
                  value={filter}
                  className='form-control input-sm w-auto'
                  onChange={this.handleFilterChange}
                  placeholder={get(msg, ['dialog', 'textRow', 'search'])}
                />
              </td>
            </tr>
          </thead>
          <tbody>{this.getTableRows(filteredItems)}</tbody>
        </table>
        {touched && error ? (
          <FormErrorMessage>{msg.validation[error]}</FormErrorMessage>
        ) : null}
      </div>
    );
  }
}
